import { AbstractControl, ValidatorFn, Validators } from '@angular/forms';

export const gitBranchNameValidator: ValidatorFn = Validators.pattern('^[A-Za-z][A-Za-z0-9_-]*[A-Za-z0-9]$');

export function isGitBranchNameValid(value: string): boolean {
  const v = gitBranchNameValidator({ value } as AbstractControl);
  return v === null;
}
